// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=512bacb0-3ec7-4230-a214-2f40fcadf7cd";
};